var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"events"}},[_c('h3',[_vm._v("Events")]),_c('h4',[_vm._v("<vsb-sidebar /> component")]),_c('b-table',{attrs:{"items":_vm.sidebarEvents}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }